// extracted by mini-css-extract-plugin
export default {"Container":"AdminHome_Container__5BUHI","Header":"AdminHome_Header__oV+QE"};